import type { AmendmentsAndCancellationsZendeskFormConfig } from 'Types/zendesk';

/**
 * Zendesk for passing values in the URL requires to use field ID. For some fields these are readable strings
 * e.g. subject, but for custom fields, which we mainly use, it requires to use number IDs. For readability,
 * this is a dictionary where keys are field's destination and values are zendesk IDs.
 *
 * Docs: https://support.zendesk.com/hc/en-us/articles/4408839114522
 */
export const AmendmentsAndCancellationsZendeskFormProductionConfig: AmendmentsAndCancellationsZendeskFormConfig = {
	dealershipNameFieldId: '7003590195740',
	emailFieldId: 'anonymous_requester_email',
	formId: '6990481348892',
	subjectFieldId: 'subject',
	vrmFieldId: '7003595820060',
};

export const AmendmentsAndCancellationsZendeskFormStagingConfig: AmendmentsAndCancellationsZendeskFormConfig = {
	// TODO: Replace production config spread and field ids after integration with zendesk staging env.
	...AmendmentsAndCancellationsZendeskFormProductionConfig,
	// dealershipNameFieldId: '',
	// emailFieldId: 'anonymous_requester_email',
	// formId: '',
	// subjectFieldId: 'subject',
	// vrmFieldId: '',
};
